import { ILogin } from "@/interfaces/login.interface";
import {
  PayloadAction,
  createListenerMiddleware,
  createSlice,
} from "@reduxjs/toolkit";
import { localAPI } from "@/services/local.service";
import { readAccessTokenForRequest } from "@/lib/auth-session";

const initialState: ILogin = {
  Id: null,
  LogoId: null,
  Titulo: "",
  Identificador: "",
  Identificadores: "",
  logo: null,
  Slug: null,
  Whatsapp: null,
  Gateway: null,
  LimiteAnexos: null,
  LimiteEventos: null,
  Status: null,
  Locais: null,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    SetLogin(state: ILogin, { payload }: PayloadAction<any>) {
      state.LogoId = payload.LogoId;
      state.Titulo = payload.Titulo;
    },
    SetLocais(state: ILogin, { payload }: PayloadAction<any>) {
      state.Locais = payload;
    },
  },
});

export const { SetLogin, SetLocais } = loginSlice.actions;
export const loginReducer = loginSlice.reducer;

/** Tipo estável do action — evita import ciclico auth ↔ login. */
const AUTH_SET_AUTHENTICATED_USER = "authSlice/setAuthenticatedUser";

export const loginMiddleware = createListenerMiddleware();
loginMiddleware.startListening({
  predicate: (action) => action.type === AUTH_SET_AUTHENTICATED_USER,
  effect: async (_action, listenerApi) => {
    listenerApi.cancelActiveListeners();
    // Sem token (ex.: logout/inscrição pública) /locais/byLogin só devolveria 401.
    if (!readAccessTokenForRequest((listenerApi.getState() as { authReducer?: { access_token?: string } }).authReducer?.access_token)) return;
    listenerApi.dispatch(
      localAPI.endpoints.getLocais.initiate(null, {
        forceRefetch: true,
      }),
    );
  },
});
